export const PER_PAGE_TRANSACTIONS = 50;
export const ALL_CARDS_PER_PAGE = 50;
